import SnapActor from './SnapActor';
import getSymbol from '../style';

/**
 * 要素捕捉行为类,用于对指定要素类型进行捕捉其形状点
 * 对应的指定要素类型一般是通过传入指定要素的场景图层id实现.
 */
export default class FeatureNearestVertexSnapActor extends SnapActor {
    constructor(options) {
        super({
            filter: null, // 过滤函数
            snapStart: true,
            snapEnd: true,
            range: 0, // 最大捕捉范围，0：不限制；单位为像素
            ...options
        });

        /**
         * 捕捉到的要素对象
         * @type {object}
         */
        this.snapFeature = null;
    }

    /**
     * 捕捉方法
     * @param {object<geojson>} point 点经纬度几何，一般是鼠标的位置
     * @returns {object} snapResult - 捕捉结果
     */
    snap(point) {
        super.snap(point);

        const box = this.getBox(point);
        const features = this._featureSelector.selectByGeometry(box, this.options.filter);

        if (features.length === 0) {
            return null;
        }

        let minDis = this.options.range || Number.MAX_VALUE;
        const pointPixel = this._geojsonConverter.toPoint(point);
        for (let i = 0; i < features.length; ++i) {
            const feature = features[i];
            const vertexes = this._getVertexes(feature.geometry);
            for (let j = 0; j < vertexes.length; j++) {
                if (!this.options.snapStart && j === 0) {
                    continue;
                }
                if (!this.options.snapEnd && j === vertexes.length - 1) {
                    continue;
                }

                const dis = pointPixel.distanceTo(vertexes[j]);
                if (dis < minDis) {
                    minDis = dis;
                    this.snapPoint = vertexes[j];
                    this.snapFeature = feature;
                    this.vertexIndex = j;
                }
            }
        }
        if (this.snapPoint) {
            this.snapPoint = this._geojsonConverter.fromPoint(this.snapPoint);
        }

        return this.getSnapResult();
    }

    getSnapResult() {
        const result = super.getSnapResult();
        if (result) {
            result.feature = this.snapFeature;
            result.vertexIndex = this.vertexIndex;

            return result;
        }

        return null;
    }

    /**
     * 获取几何的形状点列表
     * @param {object}  geometry - 几何对象
     * @returns {array} 形状点几何对象列表
     */
    _getVertexes(geometry) {
        const vertexes = [];
        const pixelGeo = this._geojsonConverter.lngLatToPixel(geometry);
        if (pixelGeo.type === 'Point') {
            vertexes.push(L.point(pixelGeo.coordinates));
        } else if (pixelGeo.type === 'LineString') {
            for (const coord of pixelGeo.coordinates) {
                vertexes.push(L.point(coord));
            }
        } else if (pixelGeo.type === 'Polygon') {
            for (const coord of pixelGeo.coordinates[0]) {
                vertexes.push(L.point(coord));
            }
        }

        return vertexes;
    }

    /**
     * 获取捕捉时的要绘制的图标信息
     * @return {array}
     */
    getDrawItems() {
        if (this.snapPoint) {
            return [
                {
                    geometry: this.snapPoint, // geojson
                    symbol: getSymbol('snap_pt_vector') // symbol json
                }
            ];
        }
        return [];
    }
}
